// EVENTS.VIEWS.APP.ONBOARDING

export const ONBOARDING = {
  PAGE_VISITED: 'onboarding-page_visited'
};
